export function setHomeTab (state, value) {
  state.homeTab = value
}

export function setMapTools (state, tools) {
  state.mapTools = tools
}
